import Vue from 'vue'
import store from '../../store/index.js'
Vue.prototype.$isEmpty = function(str) {
    if (str == null || str == '' || str == undefined || str == NaN) {
        return true
    };
    return false;
}

// Vue.prototype.$userInfo = function() {
//     let username = window.sessionStorage.getItem('userName');
//     let password = window.sessionStorage.getItem('passPwd');
//     let token = window.sessionStorage.getItem('token');

//     if (this.$isEmpty(username) || this.$isEmpty(password) || this.$isEmpty(token)) {
//         this.$router.push('/login')
//         return false
//     }
// }

Vue.prototype.$closeData = function() {
    window.sessionStorage.removeItem('userCode')
    window.sessionStorage.removeItem('userCompany')
    window.sessionStorage.removeItem('userName')
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('userId')
    store.commit('setUserName', '')
    store.commit('setUserCode', '')
    store.commit('setUserCompany', '')
    store.commit('setToken', '')
    store.commit('setUserId', '')
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js